import {ReactNode} from 'react'
import {toast} from '@utilities/toast'

export const showFloorPlanSettingsToast = ({
    title,
    description,
    duration = 10_000
}: {
    title: string
    description: ReactNode
    duration?: number
}) =>
    toast.info(
        <div className="flex flex-col gap-1 [&_strong]:text-md [&_strong]:font-medium [&_strong]:text-neutral-900 [&_span]:text-sm [&_span]:text-neutral-700">
            <strong>{title}</strong>
            <span>{description}</span>
        </div>,
        {position: 'bottom-right', duration}
    )
